import React from 'react'

const ReadySection = ({ activeType, t }) =>
    !activeType.isActive ? (
        <div className="ready-section">
            <div className="ready-section__bg" style={{ backgroundColor: activeType.colors.main }} />
            <h2>{t('Want to be among the first to try?')}</h2>
            <p>
                {t(
                    'Submit your application and we will send you an invitation as soon as the format becomes available.',
                )}
            </p>
            <div className="ready-section__buttons">
                <button className="button" data-size="lg" data-variant="transparent" disabled>
                    {t('Coming soon')}
                </button>
                <a
                    href="mailto:info@interacty.me"
                    className="button-style"
                    data-size="lg"
                    data-variant="black-white--2"
                >
                    {t(`send request`)}
                </a>
            </div>
        </div>
    ) : null

export default ReadySection
